import {vmImage, vmImageBackground} from '@fremcast/section/Image';
import {videoRoute, customRoute, iconRoute} from '@fremcast/section/RouteLink';
import FremcastImage from "@fremcast/section/ImageVideoCard";
import section from '@fremcast/section/mixins/section';
import card from '@fremcast/section/mixins/card';
import * as SectionsConfig from '@fremcast/section/config';
import stylesButton from "@fremcast/section/mixins/stylesButton";

export default {
  data() {
    return {
      sectionSelectedId: 0,
      //sectionTextColor: "#FFF",
      blockStyle: 'card',
      sectionSelectedBlockId: 0
    };
  },
  created() {
    //this.blockStyle = this.sectionSelected.settings.blockStyle.toLowerCase();
    this.textColor = this.sectionSelected.titleColor;
    this.sectionSelectedId = this.sectionSelected.sectionId;
    this.sectionSelectedBlockId = this.sectionSelected.id
  },
  props: [
    'data',
    'css'
  ],
  components: {
    vmImage,
    videoRoute,
    customRoute,
    vmImageBackground,
    iconRoute,
    FremcastImage
  },
  mixins: [
    section,
    card,
    stylesButton
  ],
  computed: {
    isDesktop() {
      const lgUp = ['lgDown', 'xl']
      return lgUp.indexOf(this.$mq) > -1
    },
    isMobile() {
      const mdDown = ['mdDown', 'smDown', 'xsDown']
      return mdDown.indexOf(this.$mq) > -1
    }
  },
  watch: {
    sectionSelected: {
      handler: function (value) {
        //this.blockStyle = value.settings.blockStyle.toLowerCase();
      },
      deep: true
    }
  }
}
